import Cookies from 'universal-cookie';

import type { PluginFlowToken } from './abstract/auth-abstract.service';

export interface CookieToken {
  accessToken: string;
  expiresAt: number;
}

export class CookieService {
  static readonly cookieName = 'NOA_HUB_AUTH';
  static readonly cookies = new Cookies();

  public static SetSession(token: PluginFlowToken) {
    const exDate: Date = new Date();

    exDate.setSeconds(exDate.getSeconds() + token.expiresIn);

    const cookieToken: CookieToken = {
      accessToken: token.accessToken,
      expiresAt: exDate.getTime(),
    };

    this.cookies.set(this.cookieName, cookieToken, {
      expires: exDate,
      path: '/',
      httpOnly: false,
      secure: true,
      sameSite: 'none',
    });
  }

  public static GetSession(): string | undefined {
    return this.cookies.get<CookieToken>(this.cookieName)?.accessToken;
  }

  public static GetSessionExpiration(): number | undefined {
    return this.cookies.get<CookieToken>(this.cookieName)?.expiresAt;
  }

  public static GetSessionToken(): CookieToken | undefined {
    return this.cookies.get<CookieToken>(this.cookieName);
  }

  public static RemoveSession(): void {
    this.cookies.remove(this.cookieName, {
      path: '/',
      httpOnly: false,
      secure: true,
      sameSite: 'none',
    });
  }
}
